import { createAction } from '@reduxjs/toolkit';

import { ModalName } from '../../enums';

export const openModal = createAction<{ modalName: ModalName; props?: unknown }>('modals.open-modal');
export const closeModal = createAction<{ modalName: ModalName }>('modals.close-modal');
